module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("79S6D"))).then(() => parcelRequire('cvs7o'));